import { useEffect, useState } from "react";
import {
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Collapse,
  FormRadio,
  ButtonGroup,
  Button,
  Col,
} from "shards-react";
import { connect } from "react-redux";
import { reorderThumbnails } from "../../../utils/redux/actions";
import { DRAG_AND_DROP_CONSTANTS } from "utils/dndBoard/constants";
import CommentarField from "./CommentarField";

const isSameOrder = (currentIds = [], targetIds = []) =>
  currentIds.length === targetIds.length &&
  currentIds.every((id, i) => id === targetIds[i]);

const ColumnHeader = (props) => {
  const {
    dispatch,
    dragHandleProps,
    columnId,
    title,
    showDropdown,
    docTypesList,
    thumbnails,
    showComment,
    sortByPage,
    pages,
  } = props;

  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [checkedType, setCheckedType] = useState();
  const [typesList, setTypesList] = useState([]);
  const [editTitle, setEditTitle] = useState({ visible: false });

  const showSortButton = sortByPage && !sortByPage.automaticSort;

  const sortPages = (pages) => {
    const sortedPages = [...pages].sort((a, b) => a.pageNumber - b.pageNumber);
    const sortedPageIds = sortedPages.map((page) => page.id);

    const currentOrder = pages.map((p) => p.id);

    if (isSameOrder(currentOrder, sortedPageIds)) return;

    const newThumbnails = {
      ...thumbnails,
      columns: {
        ...thumbnails.columns,
        [columnId]: {
          ...thumbnails.columns[columnId],
          pageIds: sortedPageIds,
        },
      },
    };
    dispatch(reorderThumbnails(newThumbnails));
  };

  const removeType = () => {
    const { [columnId]: columnToRemove, ...restColumns } = thumbnails.columns;

    const newOrder = {
      ...thumbnails,
      columnOrder: thumbnails.columnOrder.filter((id) => id !== columnId),
      columns: {
        ...restColumns,
        not_detected: {
          ...thumbnails.columns[DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE],
          pageIds: [
            ...thumbnails.columns[DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE]
              .pageIds,
            ...columnToRemove.pageIds,
          ],
        },
      },
    };
    dispatch(reorderThumbnails(newOrder));
  };

  const changeType = () => {
    const { value: newType } = editTitle;
    const { [columnId]: columnToRemove, ...restColumns } = thumbnails.columns;

    const newOrder = { ...thumbnails, columns: { ...restColumns } };

    if (columnId === DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE) {
      newOrder.columns[DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE] = {
        ...columnToRemove,
        pageIds: [],
      };
    } else {
      newOrder.columnOrder = newOrder.columnOrder.filter(
        (id) => id !== columnId
      );
    }

    if (newOrder.columns[newType.shortName]) {
      newOrder.columns[newType.shortName] = {
        ...newOrder.columns[newType.shortName],
        pageIds: [
          ...newOrder.columns[newType.shortName].pageIds,
          ...columnToRemove.pageIds,
        ],
      };
    } else {
      let addAtIndex = thumbnails.columnOrder.indexOf(columnId);

      if (addAtIndex < 0) addAtIndex = newOrder.columnOrder.length;

      newOrder.columnOrder.splice(addAtIndex, 0, newType.shortName);

      newOrder.columns = {
        ...newOrder.columns,
        [newType.shortName]: {
          id: newType.shortName,
          pageIds: columnToRemove.pageIds,
          shortName: newType.shortName,
          title: newType.displayName,
          typesIncluded: newType.typesIncluded,
        },
      };
    }
    dispatch(reorderThumbnails(newOrder));
  };

  useEffect(() => {
    if (!sortByPage?.automaticSort || !pages?.length) return;

    const sortedIds = [...pages]
      .sort((a, b) => a.pageNumber - b.pageNumber)
      .map((p) => p.id);
    const currentIds = pages.map((p) => p.id);

    if (isSameOrder(currentIds, sortedIds)) return;

    sortPages(pages);
  }, [pages, sortByPage?.automaticSort]);

  return (
    <Row noGutters {...dragHandleProps} className="mr-1 mb-1">
      <Col className="scroll-text-wrapper">
        <span className="scroll-text font-weight-bold pr-2">
          {title}
          <span className="ml-1 font-weight-normal">{`- Anzahl Seiten: ${pages.length}`}</span>
        </span>
      </Col>
      {showDropdown && (
        <Dropdown
          className="nav-link-icon"
          open={toggleDropdown}
          toggle={() => {
            if (editTitle.visible) setEditTitle({ visible: false });
            setToggleDropdown((oldState) => !oldState);
          }}
        >
          <DropdownToggle
            tag="i"
            className="fas fa-ellipsis-v p-1 mr-n1 my-n2 text-warning pointer"
          />
          {toggleDropdown && (
            <DropdownMenu right className="p-0 mr-n1">
              <DropdownItem
                tag="div"
                className="px-2 py-1 rounded"
                toggle={false}
              >
                <Row
                  noGutters
                  className="d-flex align-items-center text-warning pointer flex-nowrap"
                  onClick={() => {
                    setCheckedType(title);
                    setTypesList(docTypesList);
                    setEditTitle({ visible: !editTitle.visible });
                  }}
                >
                  <div className="dropdown-icon">
                    <i className="fas fa-edit" />
                  </div>
                  <strong className="text-dark ml-2 text-nowrap">
                    Typ ändern
                  </strong>
                  {editTitle.value && (
                    <ButtonGroup>
                      <Button
                        theme="success"
                        className="py-0"
                        size="sm"
                        pill
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          changeType();
                          setEditTitle({ visible: false });
                          setToggleDropdown(false);
                        }}
                      >
                        <i className="far fa-check-circle" />
                      </Button>
                      <Button
                        theme="danger"
                        className="py-0"
                        size="sm"
                        pill
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          setToggleDropdown(false);
                        }}
                      >
                        <i className="far fa-times-circle" />
                      </Button>
                    </ButtonGroup>
                  )}
                </Row>
                {editTitle.visible && (
                  <Collapse className="mt-2" open={editTitle.visible}>
                    <InputGroup seamless>
                      <InputGroupAddon type="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <FormInput
                        className="doc-types-searchbar"
                        autoFocus
                        type="search"
                        onChange={(e) =>
                          setTypesList(
                            docTypesList.filter(({ displayName }) =>
                              displayName
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                            )
                          )
                        }
                      />
                    </InputGroup>
                    <Row
                      className="h-auto overflow-auto mt-1"
                      noGutters
                      style={{
                        maxHeight: "250px",
                        width: "197px",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      <ListGroup className="pb-1 flex-grow-1">
                        {typesList.length ? (
                          typesList.map((type, index) => (
                            <ListGroupItem
                              key={index}
                              className={`px-2 pt-2 pb-0 pointer${
                                index % 2 ? " bg-light" : ""
                              }`}
                            >
                              <FormRadio
                                checked={type.displayName === checkedType}
                                onChange={() => {
                                  setEditTitle((oldState) => ({
                                    ...oldState,
                                    value: type,
                                  }));
                                  setCheckedType(type.displayName);
                                }}
                              >
                                {type.displayName}
                              </FormRadio>
                            </ListGroupItem>
                          ))
                        ) : (
                          <ListGroupItem className="pointer text-center p-2">
                            Keine Ergebnisse
                          </ListGroupItem>
                        )}
                      </ListGroup>
                    </Row>
                  </Collapse>
                )}
              </DropdownItem>
              {showComment && <CommentarField columnId={columnId} />}
              {columnId !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE && (
                <DropdownItem
                  className="px-2 py-1 rounded"
                  onClick={removeType}
                >
                  <Row
                    noGutters
                    className="d-flex align-items-center pointer flex-nowrap"
                  >
                    <div className="dropdown-icon">
                      <i className="fas fa-times text-danger" />
                    </div>
                    <strong className="text-nowrap ml-2">Typ entfernen</strong>
                  </Row>
                </DropdownItem>
              )}
              {showSortButton && (
                <DropdownItem className="px-2 py-1 rounded" tag="div">
                  <div
                    className="d-flex align-items-center pointer"
                    onClick={() => sortPages(pages)}
                  >
                    <div className="dropdown-icon">
                      <i className="fas fa-sort text-warning" />
                    </div>
                    <strong className="text-dark ml-2 text-nowrap">
                      Nach Seite Sortieren
                    </strong>
                  </div>
                </DropdownItem>
              )}
            </DropdownMenu>
          )}
        </Dropdown>
      )}
    </Row>
  );
};

const mapStateToProps = ({
  savedDocument: { thumbnails, approved },
  docTypesList,
}) => ({ thumbnails, showDropdown: !approved, docTypesList });

export default connect(mapStateToProps)(ColumnHeader); //Export component and connect it with redux.
